export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useInfiniteAPI, } from "../../utils/use-infinite-api";
import { useMutation } from "../../utils/use-mutation";
import { authenticationFactorCreate, authenticationFactorTrigger, authenticationFactorVerify, authenticationFactorDisable, authenticationFactorDisableOrgUser, } from "./fetch";
export const useAuthenticationFactorList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.AuthenticationFactorList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useInfiniteAuthenticationFactorList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useInfiniteAPI({
        endpoint: Endpoint.AuthenticationFactorList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useAuthenticationFactorSelf = (authenticationFactorId, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.AuthenticationFactorSelf,
        endpointParams: { authenticationFactorId },
        shouldMakeRequest,
        swrOptions,
    });
};
export const useAuthenticationFactorCreate = (params) => {
    return useMutation(authenticationFactorCreate, params);
};
export const useAuthenticationFactorTrigger = (authenticationFactorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return authenticationFactorTrigger(authenticationFactorId, body, queryParams, headers);
    }, params);
};
export const useAuthenticationFactorVerify = (authenticationFactorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return authenticationFactorVerify(authenticationFactorId, body, queryParams, headers);
    }, params);
};
export const useAuthenticationFactorDisable = (authenticationFactorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return authenticationFactorDisable(authenticationFactorId, body, queryParams, headers);
    }, params);
};
export const useAuthenticationFactorDisableOrgUser = (authenticationFactorId, params) => {
    return useMutation((body, queryParams, headers) => {
        return authenticationFactorDisableOrgUser(authenticationFactorId, body, queryParams, headers);
    }, params);
};
